module.exports = __webpack_public_path__ + "static/4-min-19acebbdca11f4baeed13bd959454085.jpeg";